var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.333h512V426.67H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.13 143.534v-22.261h-22.26v22.261H78.609v22.261h22.261v22.261h22.26v-22.261h22.261v-22.261zm288 0v-22.261h-22.26v22.261h-22.261v22.261h22.261v22.261h22.26v-22.261h22.261v-22.261zm-288 202.663v-22.261h-22.26v22.261H78.609v22.261h22.261v22.261h22.26v-22.261h22.261v-22.261zm288 0v-22.261h-22.26v22.261h-22.261v22.261h22.261v22.261h22.26v-22.261h22.261v-22.261z"
}))));

export default SvgGe;